/**
 * V2, the world moves while you're away (docs/ideas/loom-v2.md, phase 5): "While you were away", the few things the
 * night's dream says happened out of the player's sight. Shown once per dream on this device: in the morning (after the
 * recap and the plate) when there is one, otherwise at the top of the story above "Previously…", in the same note. They
 * stay true either way: the player's next move takes them into the story (shared/offscreen.ts).
 */
import type { StoryView } from "../../shared/story";
import "./meanwhile.css";

const seenKey = (id: string) => `weftwake.meanwhile:${id}`;
const seenAt = (id: string) => { try { return Number(localStorage.getItem(seenKey(id)) ?? 0); } catch { return 0; } };

/** Lines waiting for this player that this device hasn't shown yet. */
export function meanwhileDue(view: StoryView | null): string[] | null {
  const m = view?.offscreen;
  return m && m.lines.length && m.at > seenAt(view.id) ? m.lines : null;
}
export function markMeanwhileSeen(view: StoryView): void {
  if (!view.offscreen) return;
  try { localStorage.setItem(seenKey(view.id), String(view.offscreen.at)); } catch { /* shown again next time */ }
}

export function Meanwhile({ lines, className = "" }: { lines: readonly string[]; className?: string }) {
  return (
    <section className={`v2-meanwhile ${className}`} aria-label="While you were away">
      <p className="v2-meanwhile-h">While you were away</p>
      <ul>{lines.map((l, i) => <li key={i} style={{ "--v2-i": i } as React.CSSProperties}>{l}</li>)}</ul>
    </section>
  );
}
